var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v(_vm._s(_vm.legHeadline))]),_c('timeline-item-station',{attrs:{"station":_vm.leg.Origin}}),_c('timeline-item-station',{attrs:{"station":_vm.leg.Destination}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }